import { render, staticRenderFns } from "./Promenada.vue?vue&type=template&id=a4ee7ae6&scoped=true"
import script from "./Promenada.vue?vue&type=script&lang=js"
export * from "./Promenada.vue?vue&type=script&lang=js"
import style0 from "./Promenada.vue?vue&type=style&index=0&id=a4ee7ae6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ee7ae6",
  null
  
)

export default component.exports